import { throttle } from "../../js/Util";

const $scrollHeader = $('.js-scroll-header');
let lastScrollTop = -1;

if ($scrollHeader.length) {
    App.W.on('scroll', throttle(showHideHeader, 100));
}

function showHideHeader() {
    let scrollTop = App.W.scrollTop();

    if (scrollTop < 0) scrollTop = 0;
    if (lastScrollTop < 0) lastScrollTop = 0;

    if ($scrollHeader.length) {
        if (scrollTop > lastScrollTop && !$scrollHeader.hasClass('_menu-opened')) {// скроллим вниз
            $scrollHeader.addClass('_header-hidden');
        } else {
            $scrollHeader.removeClass('_header-hidden');
        }
    }

    lastScrollTop = scrollTop;
}

$('.js-menu-open').on('click', function() {
    $scrollHeader.toggleClass('_menu-opened');
    if ($scrollHeader.hasClass('_menu-opened')) {
        App.lockScroll.lock();
    } else {
        App.lockScroll.unlock();
    }
});

$('.js-navigation li').on('click', function() {
    if ($(this).find('.submenu')) {
        $(this).find('.submenu').toggleClass('_sub-opened');
    }
});